import _ from "lodash";
import i18n from "../i18n";

const Analytics = {};

Analytics.createGlobalQueue = () => {
  if (!window.hasOwnProperty("ga_queue")){
    window.ga_queue = [];
  }
}

Analytics.clearQueue = () => {
  window.ga_queue = [];
}

Analytics.processQueue = () => {
  var deduped = _.uniqBy(window.ga_queue, function (e) {
    return e.page;
  });
  Analytics.clearQueue();

  // Send page views
  _.map(deduped, (o) => {
    if (
      o.page === window.location.pathname
      || _.startsWith(o.page, '/committeemember/')
      || _.startsWith(o.page, '/inductee/')
      || _.startsWith(o.page, '/category/')
      || _.startsWith(o.page, '/nominee/')
    ){
      // GTM
      window.dataLayer = window.dataLayer || [];
      var pageTitle = "unknown";
      if (o.title){
          pageTitle = o.title;
      }
      window.dataLayer.push({
         'event' : 'pageview',
         'pagePath' : o.page,
         'pageTitle' : pageTitle,
         'language': i18n.language || i18n.resolvedLanguage, // Appending the i18n variable
         'locale': i18n.language || i18n.resolvedLanguage, // Appending the i18n variable

      });
    }
  })
}

/**
 * TrackPageView - tracks page view in Google Analytics and GTM
 */
Analytics.TrackPageView = (title = false, page = window.location.pathname) => {
  Analytics.createGlobalQueue();
  if (window.hasOwnProperty('dataLayer')){
    if (title){
      window.ga_queue.push({
        page: page,
        title: title
      })
    } else {
      window.ga_queue.push({
        page: window.location.pathname,
        title: false
      })
    }
    setTimeout(Analytics.processQueue, 3000)
  }
}

/**
 * TrackCustom - tracks custom event in GTM
 * data - object containing event data to be sent to GTM dataLayer
 */
Analytics.TrackCustom = (data) => {
  Analytics.createGlobalQueue();
  if (window.hasOwnProperty('dataLayer') && data){
      data['language'] = i18n.language || i18n.resolvedLanguage; // Appending the i18n variable
      data['locale'] = i18n.language || i18n.resolvedLanguage; // Appending the i18n variable
      window.dataLayer.push(data);
  }
}

export default Analytics;
